import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from '@angular/router';

@Component({
  selector: 'app-save-message',
  templateUrl: './save-message.component.html',
  styleUrls: ['./save-message.component.css']
})
export class SaveMessageComponent implements OnInit {
  message: any;
  badgeData: any;
  sub: any;
  constructor(
    public dialogRef: MatDialogRef<SaveMessageComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.badgeData = data;
  }

  close() {
    this.dialogRef.close();
  }

  navigate() {
    this.router.navigate([this.data.goTo]);
  }

  ngOnInit() {
    if (this.data.info == "cahngePassword") {
      this.sub = this.dialogRef.afterClosed().subscribe(() => {
        this.router.navigate(["auth"], { queryParams: { returnUrl: "profile-update/change-password", type: "login" } });
      });
    }
    if (this.data.info == "deleteAccount") {
      this.sub = this.dialogRef.afterClosed().subscribe(() => {
        this.router.navigate(["auth"], { queryParams: { returnUrl: "profile-update/delete-account", type: "login" } });
      });
    }
  }

  ngOnDestroy() {
    try {
      this.sub.unsubscribe();
    } catch (e) {
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/save-message/save-message.component.ts